import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ResourceType } from 'situview-webapi-client';

@Component({
  selector: 'tag-edit-dialog',
  templateUrl: './tag-edit-dialog.component.html',
  styleUrls: ['./tag-edit-dialog.component.scss']
})
export class TagEditDialogComponent {
  tagForm: FormGroup;
  resourceTypes = ResourceType;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<TagEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { existingName: string, resourceType: ResourceType }
  ) {
    this.tagForm = this.fb.group({
      newName: [this.data.existingName, [Validators.required, Validators.pattern(/^(?!.*\s\s)(?!^\s)(?!.*\s$)[a-zA-Z0-9 ,.\-_]{1,50}$/), this.notSameAsExisting.bind(this)]],
      resourceType: [this.data.resourceType, [Validators.required]]
    });
  }

  notSameAsExisting(control: FormControl) {
    return control.value !== this.data.existingName ? null : { sameAsExisting: true };
  }

  onRename() {
    if (this.tagForm.valid) {
      this.dialogRef.close(this.tagForm.value);
    }
  }
}


